







// vue
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    name: 'Loading'
})
export default class Loading extends Vue {
    @Prop({ default: 'primary', type: String }) color!: string
    @Prop({ default: '2', type: String }) my!: string
    @Prop({ default: true, type: Boolean }) showText!: boolean
}
